<template>
  <div class="watch-sample">
    <h3>Watch Sample</h3>
    <input type="text" id="firstValue" v-model="firstValue" />
    <input type="text" id="secondValue" v-model="secondValue" />
  </div>
</template>

<script>
import Vue from 'vue'
import {
  computed,
  onBeforeMount,
  onBeforeUpdate,
  onCreated,
  onMounted,
  onUpdated,
  value,
  watch
} from 'vue-function-api'

export default {
  name: 'WatchSample',

  setup() {
    console.log('setup')
    const firstValue = value('a')
    const secondValue = value('b')

    const computedValue = computed(() => firstValue.value + secondValue.value)

    watch(firstValue, (newValue, oldValue) => {
      console.log(`firstValue: ${oldValue} => ${newValue}`)
    })

    console.log('create watch firstValue')

    watch(
      firstValue,
      (newValue, oldValue) => {
        console.log(`firstValue | lazy: ${oldValue} => ${newValue}`)
      },
      { lazy: true }
    )

    console.log('create watch firstValue | lazy')

    watch(
      firstValue,
      (newValue, oldValue) => {
        console.log(`firstValue | pre: ${oldValue} => ${newValue}`)
      },
      { flush: 'pre' }
    )

    console.log('create watch firstValue | pre')

    watch(
      firstValue,
      (newValue, oldValue) => {
        console.log(`firstValue | post: ${oldValue} => ${newValue}`)
      },
      { flush: 'post' }
    )

    console.log('create watch firstValue | post')

    watch(
      firstValue,
      (newValue, oldValue) => {
        console.log(`firstValue | sync: ${oldValue} => ${newValue}`)
      },
      { flush: 'sync' }
    )

    console.log('create watch firstValue | sync')

    watch([firstValue, secondValue], (newValues, oldValues) => {
      console.log(`[firstValue, secondValue]: ${oldValues} => ${newValues}`)
    })

    onBeforeMount(() => console.log('before mount'))
    onBeforeUpdate(() => console.log('before update'))
    onCreated(() => console.log('created'))
    onMounted(() => console.log('mounted'))
    onUpdated(() => console.log('updated'))

    return {
      firstValue,
      secondValue,
      computedValue
    }
  }
}
</script>
